import { Reveal } from "@/components/Reveal";

const FAILURES = [
  "HESITATION",
  "OVERTRADING",
  "STRATEGY HOPPING",
  "MOVING STOPS",
  "TAKING PROFITS TOO EARLY",
  "HOLDING LOSERS TOO LONG",
  "EMOTIONAL DECISION-MAKING",
];

const PRESSURE_LINES = [
  "Fear makes you hesitate.",
  "FOMO makes you enter early.",
  "A losing trade makes you want the money back.",
  "A winning trade makes you afraid to give profit back.",
];

export default function ExecutionGapV2() {
  return (
    <section data-testid="execution-gap-section" className="py-24 lg:py-32">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="grid items-start gap-14 lg:grid-cols-2 lg:gap-20">
          <div>
            <Reveal>
              <div className="mb-5 flex items-center gap-3 font-mono text-[11px] uppercase tracking-[0.25em] text-neon/90">
                <span className="h-px w-8 bg-neon/50" />
                01 — The Execution Gap
              </div>
            </Reveal>
            <Reveal delay={0.08}>
              <h2 className="font-display text-3xl font-extrabold uppercase leading-[1.05] tracking-tight text-white sm:text-4xl lg:text-5xl">
                Knowing what to do
                <br />
                isn't the same as
                <br />
                <span className="glow-text-neon text-neon">doing it.</span>
              </h2>
            </Reveal>
            <Reveal delay={0.16}>
              <p className="mt-7 max-w-lg text-base leading-relaxed text-mist">
                You've studied trading. You've watched the videos. You've
                learned setups. You may even know exactly what a good trade
                looks like.
              </p>
            </Reveal>
            <Reveal delay={0.22}>
              <p className="mt-5 max-w-lg text-base font-semibold text-white">
                Then the market opens.
              </p>
            </Reveal>
            <div className="mt-5 space-y-2">
              {PRESSURE_LINES.map((l, i) => (
                <Reveal key={l} delay={0.26 + 0.06 * i}>
                  <p className="font-mono text-sm leading-relaxed text-mist">{l}</p>
                </Reveal>
              ))}
            </div>
            <Reveal delay={0.55}>
              <p className="mt-5 max-w-lg text-base leading-relaxed text-mist">
                And suddenly the plan you understood before the trade disappears
                during the trade.
              </p>
            </Reveal>
          </div>

          <div className="panel rounded-lg p-6 sm:p-8">
            <Reveal>
              <div className="mb-6 font-mono text-[10px] uppercase tracking-[0.25em] text-dim">
                Where execution breaks down
              </div>
            </Reveal>
            <div className="flex flex-wrap gap-2.5">
              {FAILURES.map((f, i) => (
                <Reveal key={f} delay={0.05 * i}>
                  <span className="inline-block rounded-md border border-line bg-ink px-3.5 py-2 font-mono text-[11px] uppercase tracking-[0.14em] text-mist transition-colors duration-300 hover:border-risk/50 hover:text-risk">
                    {f}
                  </span>
                </Reveal>
              ))}
            </div>
            <Reveal delay={0.3}>
              <div className="mt-8 border-t border-line pt-6">
                <p className="font-mono text-[11px] uppercase leading-relaxed tracking-[0.18em] text-dim">
                  The problem isn't always what you know.
                  <br />
                  <span className="text-white">
                    Sometimes it's what you do with what you know.
                  </span>
                </p>
              </div>
            </Reveal>
          </div>
        </div>

        <Reveal delay={0.1}>
          <div className="mt-20 border-t border-line pt-14 sm:mt-24">
            <h3 className="max-w-4xl font-display text-3xl font-extrabold uppercase leading-[1.08] tracking-tight text-white sm:text-5xl">
              That's the
              <br />
              <span className="glow-text-neon text-neon">execution gap.</span>
            </h3>
            <p className="mt-6 max-w-2xl text-base leading-relaxed text-mist">
              The difference between knowing a trading process and consistently
              following it under real market pressure.{" "}
              <span className="text-white">
                P.E.E. was built to help close that gap.
              </span>
            </p>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
